module.exports = __webpack_public_path__ + "media/images/post/bgi-post-travel-0274b249f52e23a22d500c9204f5ac61.jpg";